import { PropCatalogType } from "building-types/settings/settingsTypesEnum";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_254: DocMigration = {
  maxSchemaVersion: "0.0.254",
  description: "Fix prop catalog links of exterior lamps",
  apply(json: any) {
    for (const propId in json.props) {
      const prop = json.props[propId];
      if (prop.catalogType === PropCatalogType.INTERIOR_PROP_CATALOG && prop.propType === "exteriorLamp") {
        prop.catalogType = PropCatalogType.EXTERIOR_PROP_CATALOG;
      }
    }
    return json;
  },
};

export default migration_0_0_254;
